import { render, staticRenderFns } from "./mybankOrderShareRefundDetail.vue?vue&type=template&id=99adb172&scoped=true"
import script from "./mybankOrderShareRefundDetail.vue?vue&type=script&lang=js"
export * from "./mybankOrderShareRefundDetail.vue?vue&type=script&lang=js"
import style0 from "./mybankOrderShareRefundDetail.vue?vue&type=style&index=0&id=99adb172&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99adb172",
  null
  
)

export default component.exports